import frontendExtensionsExplorerPlugin from '@terasky/backstage-plugin-frontend-extensions-explorer';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const frontendExtensionsExplorerPageOverride = frontendExtensionsExplorerPlugin
  .getExtension('page:frontend-extensions-explorer')
  .override({
    params: {
      noHeader: true,
    },
  });

export const frontendExtensionsExplorerPluginOverride = createFrontendModule({
  pluginId: 'frontend-extensions-explorer',
  extensions: [frontendExtensionsExplorerPageOverride],
});
